import { createGlobalStyle } from "styled-components"

// Sora (from @fontsource/sora 4.5.12) served from static/fonts/, so the font
// files are not inlined into every page as base64 the way the @fontsource
// CSS imports were, and the main ones can be preloaded (gatsby-ssr.js).
// Bump the "-v4" in the file names when the files change: /fonts/* is cached
// for a year (netlify/edge-functions/asset-cache.js).
export const SORA_WEIGHTS = [300, 400, 500, 600]

const LATIN =
  "U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD"
const LATIN_EXT =
  "U+0100-024F,U+0259,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF"

export const soraFontUrl = (subset, weight) =>
  `/fonts/sora-${subset}-${weight}-normal-v4.woff2`

const fontFace = (subset, weight, unicodeRange) => `
  @font-face {
    font-family: "Sora";
    font-style: normal;
    font-display: swap;
    font-weight: ${weight};
    src: url("${soraFontUrl(subset, weight)}") format("woff2");
    unicode-range: ${unicodeRange};
  }
`

const FontFaces = createGlobalStyle`
  ${SORA_WEIGHTS.map(
    weight => fontFace("latin-ext", weight, LATIN_EXT) + fontFace("latin", weight, LATIN)
  ).join("")}
`

export default FontFaces
